import React from "react"
import { LogosContainer, LogoWrapper } from "./mixins"
import logoGPTW from '../../../../../assets/images/calificar-empresas/GPTW_Logo.svg'
import logoEmpresaPro from '../../../../../assets/images/calificar-empresas/empresa-pro.svg'

interface LogosProps {
  empresaPro?: boolean
  showGptw: boolean
}

const Logos = ({ empresaPro, showGptw }: LogosProps) => {
  return showGptw || empresaPro ? (
    <LogosContainer>
      {showGptw && (
        <LogoWrapper>
          <img width="100%" height="40px" src={logoGPTW} alt="logo GPTW" />
        </LogoWrapper>
      )}
      {empresaPro && (
        <LogoWrapper>
          <img width="100%" height="40px" src={logoEmpresaPro} alt="logo Empresa Pro" />
        </LogoWrapper>
      )}
    </LogosContainer>
  ) : null
}

export default Logos